module.exports = __webpack_public_path__ + "img/QA_pin03.bc265963.svg";